// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"2219359c","258":"a7fd73bf","377":"448226b5","417":"0b6606cd","467":"b6b327b0","626":"e5e40771","870":"6742c20e"}[chunkId] + ".js";
};